/**
 * Prepare wallet condition data before sending to backend
 *
 * This utility filters out invalid presetConfigs and conditionally includes poolPresetConfigs
 * based on the usePool flag, following the pattern from DepositPromotionForm.
 *
 * @param walletCondition - The wallet condition form values
 * @returns Cleaned wallet condition data ready for API submission
 *
 * @example
 * ```tsx
 * const handleSubmit = (values: FormValues) => {
 *   const payload = {
 *     ...values,
 *     walletCondition: prepareWalletConditionForSubmit(values.walletCondition)
 *   }
 *   onSubmit(payload)
 * }
 * ```
 */
export function prepareWalletConditionForSubmit(walletCondition?: any) {
	if (!walletCondition) return undefined

	const { poolPresetConfigs, presetConfigs, usePool, ...restValues } =
		walletCondition

	const hasValidThreshold = (config: any) => {
		if (config.thresholdType === 'MULTIPLIER') {
			return (
				config.turnoverMultiplier !== null &&
				config.turnoverMultiplier !== undefined &&
				config.presetId
			)
		}
		return (
			config.turnoverThreshold !== null &&
			config.turnoverThreshold !== undefined &&
			config.presetId
		)
	}

	return {
		...restValues,
		// Only include presetConfigs that have valid presetId and threshold is not null/undefined
		presetConfigs: presetConfigs?.some(hasValidThreshold)
			? presetConfigs.filter(hasValidThreshold)
			: [],
		// Only include poolPresetConfigs if usePool is true
		...(usePool ? { poolPresetConfigs } : {}),
	}
}
